<template>
  <!-- 订单 -->
  <div class="hepl-tool order" v-if="showType=='order'&&level==1">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/1/b101.png" alt="">
      <div class="click" @click="hide()"></div>
      <div class="click b1" @click="index++"></div>
    </div>
    <div class="box" v-if="index<2">
      <img src="@static/images/helpTool/1/b102.png" alt="">
      <div class="click b2" @click="hide()"></div>
      <div class="click b3" @click="index++"></div>
    </div>
    <div class="box" v-if="index<3">
      <img src="@static/images/helpTool/1/b103.png" alt="">
      <div class="click b4" @click="hide()"></div>
      <div class="click b5" @click="index++"></div>
    </div>
    <div class="box" v-if="index<4">
      <img src="@static/images/helpTool/1/b104.png" alt="">
      <div class="click b6" @click="hide()"></div>
      <div class="click b7" @click="index++"></div>
    </div>
    <div class="box" v-if="index<5">
      <img src="@static/images/helpTool/1/b105.png" alt="">
      <div class="click b8" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='order'&&level==2">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/2/b201.png" alt="">
      <div class="click b15" @click="hide()"></div>
      <div class="click b1" @click="index++"></div>
    </div>
    <div class="box" v-if="index<2">
      <img src="@static/images/helpTool/2/b202.png" alt="">
      <div class="click b9" @click="hide()"></div>
      <div class="click b10" @click="index++"></div>
    </div>
    <div class="box" v-if="index<3">
      <img src="@static/images/helpTool/2/b203.png" alt="">
      <div class="click b11" @click="hide()"></div>
      <div class="click b12" @click="index++"></div>
    </div>
    <div class="box" v-if="index<4">
      <img src="@static/images/helpTool/2/b204.png" alt="">
      <div class="click b13" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='order'&&level==3">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/3/b301.png" alt="">
      <div class="click" @click="hide()"></div>
      <div class="click b1" @click="index++"></div>
    </div>
    <div class="box" v-if="index<2">
      <img src="@static/images/helpTool/3/b302.png" alt="">
      <div class="click b9" @click="hide()"></div>
      <div class="click b10" @click="index++"></div>
    </div>
    <div class="box" v-if="index<3">
      <img src="@static/images/helpTool/3/b303.png" alt="">
      <div class="click b11" @click="hide()"></div>
      <div class="click b12" @click="index++"></div>
    </div>
    <div class="box" v-if="index<4">
      <img src="@static/images/helpTool/3/b304.png" alt="">
      <div class="click b14" @click="hide()"></div>
    </div>
  </div>
  <!-- 首页 -->
  <div class="hepl-tool order" v-else-if="showType=='index'&&level==1">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/1/a101.png" alt="">
      <div class="click a0" @click="hide()"></div>
      <div class="click a1" @click="index++"></div>
    </div>
    <div class="box" v-if="index<2">
      <img src="@static/images/helpTool/1/a102.png" alt="">
      <div class="click a2" @click="hide()"></div>
      <div class="click a3" @click="index++"></div>
    </div>
    <div class="box" v-if="index<3">
      <img src="@static/images/helpTool/1/a103.png" alt="">
      <div class="click a4" @click="hide()"></div>
      <div class="click a5" @click="index++"></div>
    </div>
    <div class="box" v-if="index<4">
      <img src="@static/images/helpTool/1/a104.png" alt="">
      <div class="click a6" @click="hide()"></div>
      <div class="click a7" @click="index++"></div>
    </div>
    <div class="box" v-if="index<5">
      <img src="@static/images/helpTool/1/a105.png" alt="">
      <div class="click a8" @click="hide()"></div>
      <div class="click a9" @click="index++"></div>
    </div>
    <div class="box" v-if="index<6">
      <img src="@static/images/helpTool/1/a106.png" alt="">
      <div class="click a10" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='index'&&level==2">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/2/a201.png" alt="">
      <div class="click a0" @click="hide()"></div>
      <div class="click a1" @click="index++"></div>
    </div>
    <div class="box" v-if="index<2">
      <img src="@static/images/helpTool/2/a202.png" alt="">
      <div class="click a2" @click="hide()"></div>
      <div class="click a3" @click="index++"></div>
    </div>
    <div class="box" v-if="index<3">
      <img src="@static/images/helpTool/2/a203.png" alt="">
      <div class="click c1" @click="hide()"></div>
      <div class="click c2" @click="index++"></div>
    </div>
    <div class="box" v-if="index<4">
      <img src="@static/images/helpTool/2/a204.png" alt="">
      <div class="click c3" @click="hide()"></div>
      <div class="click c4" @click="index++"></div>
    </div>
    <div class="box" v-if="index<5">
      <img src="@static/images/helpTool/2/a205.png" alt="">
      <div class="click c5" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='index'&&level==3">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/3/a301.png" alt="">
      <div class="click a0" @click="hide()"></div>
      <div class="click a1" @click="index++"></div>
    </div>
    <div class="box" v-if="index<2">
      <img src="@static/images/helpTool/3/a302.png" alt="">
      <div class="click a2" @click="hide()"></div>
      <div class="click a3" @click="index++"></div>
    </div>
    <div class="box" v-if="index<3">
      <img src="@static/images/helpTool/3/a303.png" alt="">
      <div class="click a11" @click="hide()"></div>
      <div class="click a12" @click="index++"></div>
    </div>
    <div class="box" v-if="index<4">
      <img src="@static/images/helpTool/3/a304.png" alt="">
      <div class="click a13" @click="hide()"></div>
    </div>
  </div>
  <!-- 订单详情 -->
  <div class="hepl-tool order" v-else-if="showType=='orderDetail'&&level==1">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/1/c101.png" alt="">
      <div class="click" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='orderDetail'&&level==2">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/2/c201.png" alt="">
      <div class="click" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='orderDetail'&&level==3">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/3/c301.png" alt="">
      <div class="click" @click="hide()"></div>
    </div>
  </div>
  <!-- 人核单 -->
  <div class="hepl-tool order" v-else-if="showType=='orderRH'&&level==1">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/1/d101.png" alt="">
      <div class="click d4" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='orderRH'&&level==2">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/2/d201.png" alt="">
      <div class="click d6" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='orderRH'&&level==3">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/3/d301.png" alt="">
      <div class="click d1" @click="hide()"></div>
    </div>
  </div>
  <!-- 续保单 -->
  <div class="hepl-tool order" v-else-if="showType=='orderXB'&&level==1">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/1/e101.png" alt="">
      <div class="click d3" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='orderXB'&&level==2">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/2/e201.png" alt="">
      <div class="click d5" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='orderXB'&&level==3">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/3/e301.png" alt="">
      <div class="click d2" @click="hide()"></div>
    </div>
  </div>
  <!-- 客户 -->
  <div class="hepl-tool order" v-else-if="showType=='customer'&&level==1">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/1/f101.png" alt="">
      <div class="click f1" @click="hide()"></div>
    </div>
  </div>
  <!-- 预约顾问 -->
  <div class="hepl-tool order" v-else-if="showType=='adviser'&&level==1">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/1/g101.png" alt="">
      <div class="click g1" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='adviser'&&level==2">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/2/g201.png" alt="">
      <div class="click g1" @click="hide()"></div>
    </div>
  </div>
  <div class="hepl-tool order" v-else-if="showType=='adviser'&&level==3">
    <div class="box" v-if="index<1">
      <img src="@static/images/helpTool/3/g301.png" alt="">
      <div class="click g1" @click="hide()"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["type"],
  data() {
    return {
      level:1,
      index:1,
      showType:""
    };
  },
  watch: {
    type:{
      handler(){
        console.log(this.type);
        if(this.type){
          this.open(this.type);
        }
      },
      immediate: true
    }
  },
  computed: {},
  created() {
    const userinfo = this.$tools.getLocal("userinfo");
    this.level = userinfo.level;
  },
  methods: {
    open(type){
      // const adminHelp = localStorage.adminHelp||"";
      // if(adminHelp.includes(type)) {
      //   return;
      // }
      // this.index = 0;
      // this.showType = this.type;
      // localStorage.adminHelp = adminHelp+","+this.type
      // this.$nextTick(()=>{
      //   document.getElementById("app").className= "index-layout overflow"
      // })
    },
    hide(){
      this.showType = "";
      document.getElementById("app").className= "index-layout";
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./helpTool.scss";
</style>
